import { GridFilterValue, NumericFilterOperator } from './operators';
import { ScalarFilterValue } from './types';
import { neverReached } from 'shared/utils/neverReached';

export function matchesNumericFilter(
  operator: NumericFilterOperator,
  filterValue: ScalarFilterValue,
  cellValue: ScalarFilterValue
): boolean {
  const numValue = Number(filterValue);
  const numCell = Number(cellValue);

  switch (operator) {
    case GridFilterValue.EQUAL:
    case GridFilterValue.EQUALS:
      return numCell === numValue;
    case GridFilterValue.NOT_EQUAL:
    case GridFilterValue.NOT_EQUALS:
      return numCell !== numValue;
    case GridFilterValue.GREATER_THAN:
    case 'gt':
      return numCell > numValue;
    case GridFilterValue.LESS_THAN:
    case 'lt':
      return numCell < numValue;
    case GridFilterValue.GREATER_EQUAL:
    case 'gte':
      return numCell >= numValue;
    case GridFilterValue.LESS_EQUAL:
    case 'lte':
      return numCell <= numValue;
    default:
      return neverReached(operator);
  }
}
